import styled from "@emotion/styled"
import React from "react"
import Image from "next/image"

export const ImageRounded = (props) => {
  return <ImageRoundedStyle {...props} />
}

const ImageRoundedStyle = styled(Image)`
  position: relative;
  border-radius: 50%;
  overflow: hidden;
`
